import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { LoanOfficerHero } from './components/LoanOfficerHero';
import { LoanCard, LoanDetails } from './components/LoanCard';
import { RefinanceCard, RefinanceOpportunity } from './components/RefinanceCard';
import { ContactBanner } from './components/ContactBanner';
import { Footer } from './components/Footer';
// Mock Data
const mockLoans: LoanDetails[] = [{
  id: 'loan-1',
  propertyAddress: '742 Evergreen Terrace, Springfield, IL 62704',
  propertyType: 'Primary Residence',
  loanType: '30-Year Fixed Conventional',
  originalAmount: 385000,
  currentBalance: 362400,
  interestRate: 6.875,
  monthlyPayment: 2528,
  originationDate: 'March 2023',
  estimatedHomeValue: 465000,
  ltv: 77.9
}, {
  id: 'loan-2',
  propertyAddress: '1847 Oak Park Ave, Unit 3B, Chicago, IL 60302',
  propertyType: 'Investment Property',
  loanType: '30-Year Fixed Conventional',
  originalAmount: 275000,
  currentBalance: 268200,
  interestRate: 7.25,
  monthlyPayment: 1876,
  originationDate: 'September 2023',
  estimatedHomeValue: 310000,
  ltv: 86.5
}];
const mockOpportunities: Record<string, RefinanceOpportunity> = {
  'loan-1': {
    loanId: 'loan-1',
    isEligible: true,
    currentRate: 6.875,
    estimatedNewRate: 5.99,
    monthlySavings: 218,
    cashOutAvailable: 92600,
    breakEvenMonths: 8
  },
  'loan-2': {
    loanId: 'loan-2',
    isEligible: false,
    ineligibleReason: 'LTV too high (86.5%) — need to reach 80% LTV',
    estimatedTimeline: '~14 months at current paydown rate',
    note: 'Home value appreciation could accelerate eligibility. Contact Sarah to discuss strategies.'
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
export function App() {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <LoanOfficerHero data-id="element-1" />

      <main className="flex-grow max-w-5xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-10" data-id="element-2">
        {/* Your Loans Section */}
        <section className="mb-12" data-id="element-3">
          <div className="mb-6" data-id="element-4">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-5">
              Your Funded Loans
            </h2>
            <p className="text-gray-600 mt-1" data-id="element-6">
              Current details for the properties you've financed with us.
            </p>
          </div>

          <motion.div variants={staggerContainer} initial="hidden" animate="visible" className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7">
            {mockLoans.map(loan => <LoanCard key={loan.id} loan={loan} data-id="element-8" />)}
          </motion.div>
        </section>

        {/* Refinance Opportunities Section */}
        <section className="mb-8" data-id="element-9">
          <div className="mb-6" data-id="element-10">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-11">
              Refinance Opportunities
            </h2>
            <p className="text-gray-600 mt-1" data-id="element-12">
              Estimated insights based on current market rates and your home's
              estimated value.
            </p>
          </div>

          <motion.div variants={staggerContainer} initial="hidden" animate="visible" className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-13">
            {mockLoans.map(loan => <RefinanceCard key={`refi-${loan.id}`} opportunity={mockOpportunities[loan.id]} propertyAddress={loan.propertyAddress.split(',')[0]} data-id="element-14" />)}
          </motion.div>
        </section>

        <ContactBanner data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
    </div>;
}